import HeroGiftGuide from "./HeroGiftGuide";

class PageGiftGuide {
    constructor() {
        this.initHero();
    }

    initHero() {
        const elementHero = document.getElementById("gift-guide-hero--scene");
        if (elementHero) {
            const hero = new HeroGiftGuide(elementHero)
        }
    }
}

export default PageGiftGuide;
